<template>
  <div>
    <ServiceInfo></ServiceInfo>
  </div>
</template>

<script>
const ServiceInfo = () =>
  import(
    /* webpackChunkName: "ServiceInfo" */ "@/components/membership/service/ServiceInfo.vue"
  );
export default {
  components: {
    ServiceInfo,
  },
};
</script>
